import { Link, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Header from "@/components/feature/Header";
import Footer from "@/components/feature/Footer";

export default function NotFound() {
  const location = useLocation();
  const { t } = useTranslation();

  return (
    <div className="min-h-screen bg-background-50">
      <Header />
      <main className="relative flex min-h-[80vh] flex-col items-center justify-center px-4 pt-16 pb-20 text-center">
        <div
          aria-hidden="true"
          className="pointer-events-none absolute bottom-0 select-none text-9xl font-black text-background-100 md:text-[12rem]"
        >
          404
        </div>
        <div className="relative z-10">
          <h1 className="font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
            {t("notfound.title")}
          </h1>
          <p className="mt-2 text-sm text-foreground-500">{location.pathname}</p>
          <p className="mt-4 text-base text-foreground-700">{t("notfound.body")}</p>
          <Link
            to="/"
            className="mt-8 inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-full bg-primary-500 px-6 py-3 text-sm font-semibold text-white transition-colors hover:bg-primary-600"
          >
            <i className="ri-home-line w-4 h-4 flex items-center justify-center text-base" />
            {t("notfound.home")}
          </Link>
        </div>
      </main>
      <Footer />
    </div>
  );
}